import styles from './style.postcss';

import React from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';
import ViewNavButton from '../ViewNavButton';
import ViewNavExtra from '../ViewNavExtra';
import { testClass } from 'omni-common-ui';

const ViewNavBig = ({ children }) => {
  const childrenArr = React.Children.toArray(children);
  const className = styles.ViewNavBig;
  return <div className={className}>
    <div className={testClass('viewnav-action-buttons')}>
      {childrenArr.filter((child) => child.type === ViewNavButton)}
    </div>
    {childrenArr.find((child) => child.type === ViewNavExtra)}
  </div>;
};

ViewNavBig.propTypes = {
  children: PropTypes.arrayOf((arr) => arr.every((val) => {
    if (is.array(val) && val.every((comp) => comp.type === 'ViewNavButton')) return true;
    if (val.type === 'ViewNavButton' || val.type === 'ViewNavExtra') return true;
    return new Error(`'children' invalid. got ${val}`);
  })),
};

export default ViewNavBig;



// WEBPACK FOOTER //
// ./components/ViewNav/ViewNavBig/index.jsx